import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../CTAButton';
import { MOCKUP_IMAGE, stats } from '../../data/content';
export function Hero() {
  return <header className="w-full bg-cream px-4 pb-12 pt-8 sm:pt-12" data-id="element-154" data-mp="cvupgeeosvse">
      <div className="mx-auto w-full max-w-3xl text-center" data-id="element-155" data-mp="cujjq91oldyn">
        <p className="font-display text-sm font-bold uppercase tracking-[0.28em] text-gold-dark sm:text-base" data-id="element-156" data-mp="hv7hreobuv2d">
          Dr. Karito
        </p>
        <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.3em] text-ink-soft" data-id="element-157" data-mp="mrxxu204tqns">
          Clinical Certainty Protocol™
        </p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mt-6 font-display text-[30px] font-extrabold leading-[1.1] text-ink sm:text-5xl" data-id="element-158" data-mp="vm2jm70esbwg">
          Diagnose Complex Cases in{' '}
          <span className="italic text-gold-dark" data-id="element-159" data-mp="1aitnash489rv">15 Minutes</span>
          <span className="block" data-id="element-160" data-mp="1ah8vham6r4xp">Without Second Guessing Your Decisions</span>
        </motion.h1>

        <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-161" data-mp="9lgbr33fjcvv">
          Walk into every restorative case with a clear plan, not uncertainty. More than{' '}
          <strong className="font-semibold text-ink" data-id="element-162" data-mp="3vwu7a2adcmf2">1,200 dentists</strong> are already using
          this system to reduce remakes, improve confidence, and make better clinical decisions.
        </p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} src={MOCKUP_IMAGE} alt="Clinical Certainty Protocol 6-volume clinical system" className="mx-auto mt-6 w-full max-w-lg" data-id="element-163" data-mp="sg532my9dosk" />

        <div className="mx-auto mt-2 w-full max-w-md" data-id="element-164" data-mp="1b5bnqfim4qh0">
          <CTAButton id="hero-cta" label="GET INSTANT ACCESS NOW" data-id="element-165" data-mp="1b6wgq0pa41cr" />
        </div>
      </div>

      <div className="mx-auto mt-10 grid w-full max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-166" data-mp="16csa5ijxdvc7">
        {stats.map(stat => <div key={stat.label} className="rounded-2xl border border-gold/20 bg-white px-3 py-4 text-center" data-id="element-167" data-mp="35l0jtxqton69">
            <p className="font-display text-2xl font-bold text-gold-dark sm:text-3xl" data-id="element-168" data-mp="2qvciwxmjzqj2">
              {stat.value}
            </p>
            <p className="mt-1 text-[11px] font-semibold uppercase leading-tight tracking-wide text-ink-soft" data-id="element-169" data-mp="2vt4atrn77cn9">
              {stat.label}
            </p>
          </div>)}
      </div>
    </header>;
}